import styled from 'styled-components';

import { FormControl, Box } from '@material-ui/core';
import { DSText } from '@engenharia/ds-react';

import colors from '../../styles/theme/colors';
import spaces from '../../styles/theme/spaces';
import { sizes, devices } from '../../styles/theme/devices';
import BackgroundImage from '../../assets/logo-symbol.svg';

import SelectCountry from '../../components/SelectCountry';
import { forMd } from '../../config/_variables';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 56px 0;
  text-align: center;

  @media ${devices.laptop} {
    background-attachment: fixed;
    background-image: url(${BackgroundImage});
    background-position: -490px 160px;
    background-repeat: no-repeat;
  }

  @media (max-width: ${sizes.mobileL}) {
    height: 100%;
  }
`;

const Content = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
`;

const ContainerBanner = styled.div`
  padding: 0 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${forMd} {
    padding: 0;
  }
`;

const Card = styled.div`
  align-items: center;
  background-color: ${colors.default.white};
  border-radius: 4px;
  border: solid 1px ${colors.default.lightGrey};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  max-width: 440px;
  padding: ${spaces.small} ${spaces.medium};
  text-align: center;

  .MuiFormControl-marginNormal {
    margin-top: 0;
  }
`;

const PanelHeader = styled.div`
  margin-bottom: ${spaces.small};
`;

const HeaderContent = styled.div`
  margin: 0 0 ${spaces.small} 0;
`;

const Divider = styled.div`
  margin: 0;
  padding: 0;
  text-align: center;
`;

const DividerText = styled.span`
  background-color: #fff;
  font-family: 'Poppins', sans-serif;
  line-height: 1.35;
  margin: 0;
  padding: 0 ${spaces.small};
  position: relative;
  z-index: 2;
`;

const DividerLine = styled.hr`
  border: solid 0.5px rgba(0, 0, 0, 0.12);
  margin: 0;
  padding: 0;
  position: relative;
  top: -10px;
  z-index: 1;

  @media (max-width: ${sizes.mobileL}) {
    border: 0;
  }
`;

const SimpleDivider = styled.hr`
  border: solid 0.5px rgba(0, 0, 0, 0.12);
  margin: ${spaces.medium} 0;
  padding: 0;
  width: 100%;
`;

const EmailSuggest = styled(DSText)`
  color: #747474;
  font-weight: 400;
  margin-left: 14px;
  margin-top: 8px;
  text-align: left;

  & > strong {
    font-style: italic;
    font-weight: 700;
  }
`;

const PhoneFieldsContainer = styled(FormControl)`
  display: flex;
  flex-direction: row;
  margin-bottom: 0px;
`;

const SelectCountryField = styled(SelectCountry)`
  width: 115px;
  margin-right: 8px;
`;

const WhatsAppCheckboxContainer = styled(FormControl)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  & > .MuiCheckbox-root {
    padding: 0;
    color: #1a73e8;
  }

  & > p {
    color: #757575;
    letter-spacing: normal;
  }
`;

export {
  Card,
  Container,
  Content,
  Divider,
  DividerLine,
  DividerText,
  HeaderContent,
  PanelHeader,
  SimpleDivider,
  EmailSuggest,
  PhoneFieldsContainer,
  SelectCountryField,
  WhatsAppCheckboxContainer,
  ContainerBanner,
};
